import stylex from '@web/lib/stylex'

export const brandVars = stylex.defineVars({
  fontFamily: 'Figma Sans, sans-serif !important',
  fontVariationSettings: '"wdth" 98',
  fontOpticalSizing: 'auto',
})
